(function ($) {
    const triggerClass = 'js-config-item';
    const modalClass = 'js-config-modal';
    const priceSimpleId = 'js-simple-product-price';
    const priceId = 'js-configurator-price';
    const summatyId = 'js-configurator-accesories';
    const priceHtmlId = 'js-configurator-price-html';
    const priceSummaryId = 'js-configurator-price-html-content';
    const modalBackdropClass = 'js-config-modal-backdrop';
    const modalCloseClass = 'js-config-modal-close';
    const activeClass = 'is-active';
    const blockScrollClass = 'block-scroll';
    const loadingClass = 'is-loading';
    const lockedClass = 'is-locked';
    const hiddenClass = 'is-hidden';
    const scrollLockCountAttr = 'data-configurator-scroll-lock-count';
    const scrollLockPreexistingAttr =
        'data-configurator-scroll-lock-preexisting';
    const configModalPrefix = 'js-config-modal-';
    const configItemPrefix = 'js-config-item-';
    const productContentId = 'js-product-container';
    const priceRegularId = 'js-simple-product-regular-price';
    const nonPrefabricatedId = 'js-non-prefabricated';
    const nonPrefabricatedInputId = 'js-non-prefabricated-input';
    const expressPaypalSelectors =
        '#ppc-button-ppcp-gateway, .ppc-button-wrapper, .ppcp-button-apm';
    const expressPaypalDisabledClass = 'ppcp-disabled';
    const expressWarningId = 'mda-paypal-config-required-message';

    let selected_variation = null;

    $(document).on('ready', function () {
        if ($('body').find('#' + priceSimpleId).length > 0) {
            update_conditions();
        }

        bootstrapExpressValidation();
    });

    $('body').on('click', '.' + triggerClass, function () {
        let $that = $(this),
            target = $that.attr('data-target');

        closeModals();
        const $targetModal = $('body').find('#' + target);

        if ($targetModal.length) {
            $targetModal.each(function () {
                $(this).addClass(activeClass);
                $('body')
                    .find('.' + modalBackdropClass)
                    .addClass(activeClass);
            });
            lockPageScroll();
        }
    });

    $(document).on('show_variation', function (event, variation) {
        let $input = $('body').find('[name="addon-configurator-attributes"]');
        if ($input.length > 0) {
            let data = JSON.stringify(variation.attributes);
            $input.val(data);
        }
        selected_variation = variation;
        update_conditions();
    });

    $('body').on('click', '.' + modalBackdropClass, function () {
        closeModals(true);
    });

    $('body').on('click', '.' + modalCloseClass, function () {
        closeModals(true);
    });

    function closeModals(disable_backdrop = false) {
        $('body')
            .find('.' + modalClass)
            .each(function () {
                $(this).removeClass(activeClass);
            });
        if (disable_backdrop) {
            $('body')
                .find('.' + modalBackdropClass)
                .removeClass(activeClass);
        }

        unlockPageScroll();
    }

    function lockPageScroll() {
        const $html = $('html');
        const lockCount = parseInt($html.attr(scrollLockCountAttr), 10) || 0;

        if (lockCount === 0) {
            $html.attr(
                scrollLockPreexistingAttr,
                $html.hasClass(blockScrollClass) ? '1' : '0'
            );
        }

        $html.attr(scrollLockCountAttr, lockCount + 1);
        $html.addClass(blockScrollClass);
    }

    function unlockPageScroll() {
        const $html = $('html');
        const lockCount = parseInt($html.attr(scrollLockCountAttr), 10) || 0;

        if (lockCount <= 0) {
            return;
        }

        if (lockCount > 1) {
            $html.attr(scrollLockCountAttr, lockCount - 1);
            return;
        }

        const wasPreexistingLock =
            $html.attr(scrollLockPreexistingAttr) === '1';

        $html.removeAttr(scrollLockCountAttr);
        $html.removeAttr(scrollLockPreexistingAttr);

        if (!wasPreexistingLock) {
            $html.removeClass(blockScrollClass);
        }
    }

    const updateAttributeClass = 'js-attribute-content-update';
    const itemParamClass = 'js-config-item-param';
    const clearAttributeClass = 'js-attribute-content-clear';

    $('body').on('click', '.' + updateAttributeClass, function () {
        let $that = $(this),
            target_key = $that.attr('data-target');
        (target = configItemPrefix + target_key),
            (param_name = $that.attr('data-name')),
            ($target = $('body').find('#' + target)),
            ($param = $target.find('.' + itemParamClass)),
            ($selected = $('body').find(
                '[name="addon-configurator-selected"]'
            )),
            (selected_val = $selected.val()),
            (new_data = update_selected(selected_val, {
                target: target_key,
                value: param_name,
            }));

        $('body')
            .find('.' + updateAttributeClass)
            .removeClass('is-active');
        $that.addClass('is-active');

        $selected.val(new_data);
        update_conditions();
        $target.addClass(activeClass);
        $param.text(param_name);

        closeModals(true);
    });

    function update_selected_trigger(target_key, value) {
        let target = configItemPrefix + target_key,
            $target = $('body').find('#' + target),
            $param = $target.find('.' + itemParamClass);

        $target.addClass(activeClass);
        $param.text(value);
    }

    $('body').on('click', '.' + clearAttributeClass, function () {
        let $that = $(this),
            target_key = $that.attr('data-target');
        (target = configItemPrefix + target_key),
            ($target = $('body').find('#' + target)),
            ($selected = $('body').find(
                '[name="addon-configurator-selected"]'
            )),
            (selected_val = $selected.val()),
            (new_data = update_selected(selected_val, {
                target: target_key,
                value: '',
            }));

        $selected.val(new_data);
        update_conditions();
        $target.removeClass(activeClass);
        closeModals(true);
    });

    function update_conditions() {
        $('body')
            .find('.' + modalClass)
            .each(function () {
                $(this).addClass(loadingClass);
            });

        $('body')
            .find('#' + productContentId)
            .addClass(loadingClass);
        $('body')
            .find('.' + updateAttributeClass)
            .each(function () {
                $(this).removeClass(lockedClass);
            });
        let $selected = $('body').find('[name="addon-configurator-selected"]'),
            selected = $selected.val(),
            accesories = $('body')
                .find('[name="addon-configurator-accesories"]')
                .val(),
            selected_attributes = $('body')
                .find('[name="addon-configurator-attributes"]')
                .val();

        let simple_price =
            $('body').find('#' + priceSimpleId).length > 0
                ? $('body')
                      .find('#' + priceSimpleId)
                      .val()
                : false;

        let regular_price =
            $('body').find('#' + priceRegularId).length > 0
                ? $('body')
                      .find('#' + priceRegularId)
                      .val()
                : false;

        $('.bottom-bar').addClass('on-loading');
        $.ajax({
            url: base_url + 'wp-json/mda-frontend-configurator/update/',
            method: 'POST',
            data: {
                accesories: accesories,
                selected_attributes: selected_attributes,
                selected: selected,
                variation: selected_variation,
                simple_price: simple_price,
                regular_price: regular_price,
            },
            success: function (response) {
                $.each(response.accesories, function (key, val) {
                    if (val.fulfilled) {
                        $('body')
                            .find('#' + configModalPrefix + key)
                            .removeClass(lockedClass);
                        if (val.content) {
                            $('body')
                                .find('#' + configModalPrefix + key)
                                .html(val.content);
                        }
                    } else {
                        $('body')
                            .find('#' + configModalPrefix + key)
                            .addClass(lockedClass);
                    }
                });
                //zablokuj akcesoria jeśli zmieniły się warunki
                if (response.unselected) {
                    $.each(response.unselected, function (key, val) {
                        $('body')
                            .find('#' + configItemPrefix + key)
                            .removeClass(activeClass);

                        selected = $selected.val();
                        let new_data = update_selected(selected, {
                            target: key,
                            value: '',
                        });
                        $selected.val(new_data);
                    });
                }
                //przywróć domyślne
                if (response.selected) {
                    $.each(response.selected, function (key, val) {
                        $('body')
                            .find('#' + configItemPrefix + key)
                            .addClass(activeClass);
                        update_selected_trigger(key, val);
                    });
                }

                if (response.nonprefabricated) {
                    $('body')
                        .find('#' + nonPrefabricatedId)
                        .removeClass(hiddenClass);
                } else {
                    $('body')
                        .find('#' + nonPrefabricatedId)
                        .addClass(hiddenClass);
                }
                $('body')
                    .find('#' + nonPrefabricatedInputId)
                    .val(response.nonprefabricated);

                $('body')
                    .find('.' + modalClass)
                    .each(function () {
                        $(this).removeClass(loadingClass);
                    });
                //aktualizuj cenę
                if (response.price) {
                    $('body')
                        .find('#' + priceId)
                        .val(response.price);

                    $('body')
                        .find('#' + priceSummaryId)
                        .addClass('is-active');
                } else {
                    $('body')
                        .find('#' + priceSummaryId)
                        .removeClass('is-active');
                }
                if (response.price_html) {
                    $('body')
                        .find('#' + priceHtmlId)
                        .html(response.price_html);
                    $('.bottom-bar__js-price').html(response.price_html);
                    $('.bottom-bar').removeClass('on-loading');
                }
                if (response.summary) {
                    $('body')
                        .find('#' + summatyId)
                        .val(response.summary);
                }

                let updated_selected = $selected.val(),
                    updated_selected_arr = updated_selected
                        ? JSON.parse(updated_selected)
                        : {};

                if (updated_selected_arr) {
                    $.each(updated_selected_arr, function (key, val) {
                        update_selected_trigger(key, val);
                    });
                }

                const isVariableProduct =
                    $('form.variations_form.cart').length > 0;
                if (!isVariableProduct || selected_attributes) {
                    if ($('.configurator').hasClass('-opacity')) {
                        $('.configurator').removeClass('-opacity');
                    }
                } else {
                    $('.configurator').addClass('-opacity');
                }

                if (response.args.variation.max_qty) {
                    $("input[name='quantity']").attr(
                        'max',
                        response.args.variation.max_qty
                    );
                }

                $('body')
                    .find('#' + productContentId)
                    .removeClass(loadingClass);

                reinitSelect2();
                toggleExpress();
            },
        });
    }

    function toggleExpress(forcedValidity) {
        const isValid =
            typeof forcedValidity === 'boolean'
                ? forcedValidity
                : validateRequiredAccessories({
                      scroll: false,
                  });

        toggleStripeElement(isValid);
        togglePaypalButtons(isValid);

        return isValid;
    }

    function toggleStripeElement(isValid) {
        const $stripeElements = $('.StripeElement');
        if (!$stripeElements.length) {
            return;
        }

        if (!isValid) {
            $stripeElements.addClass('-opacity');
        } else {
            $stripeElements.removeClass('-opacity');
        }
    }

    function togglePaypalButtons(isValid) {
        const $targets = $(expressPaypalSelectors);
        if (!$targets.length) {
            setExpressWarningVisibility(false);
            return;
        }

        if (!isValid) {
            $targets
                .addClass(expressPaypalDisabledClass)
                .attr('aria-disabled', 'true')
                .css('pointer-events', 'none');
        } else {
            $targets
                .removeClass(expressPaypalDisabledClass)
                .removeAttr('aria-disabled')
                .css('pointer-events', '');
        }

        setExpressWarningVisibility(!isValid);
    }

    function getExpressWarningNode() {
        let $node = $('#' + expressWarningId);
        if (!$node.length) {
            return null;
        }

        return $node;
    }

    function setExpressWarningVisibility(visible) {
        const $node = getExpressWarningNode();
        if (!$node) {
            return;
        }

        if (visible) {
            $node.show();
        } else {
            $node.hide();
        }
    }

    function validateRequiredAccessories(options = {}) {
        const settings = {
            scroll: typeof options.scroll === 'boolean' ? options.scroll : true,
            decorate:
                typeof options.decorate === 'boolean' ? options.decorate : true,
        };

        const $requiredItems = $('.configurator__item');
        const $requiredNotSelected = $requiredItems.filter(function () {
            return (
                $(this).find('.configurator__name-required').length > 0 &&
                !$(this).hasClass('is-active')
            );
        });

        $requiredItems.removeClass('has-error').css('border', 'none');
        $('.required-warning').remove();

        if ($requiredNotSelected.length > 0) {
            const $firstInvalid = $requiredNotSelected.first();

            if (settings.decorate) {
                $firstInvalid
                    .addClass('has-error')
                    .css('border', '1px solid #d50057');
            }

            if (settings.scroll) {
                $('html, body').animate(
                    {
                        scrollTop: $firstInvalid.offset().top - 100,
                    },
                    500
                );
            }

            return false;
        }

        return true;
    }

    $('form.variations_form.cart').on('submit', function (e) {
        if (!validateRequiredAccessories()) {
            e.preventDefault();
            return false;
        }
    });

    $('.js-variation-add-to-cart').on('click', function (e) {
        if (!validateRequiredAccessories()) {
            e.preventDefault();
            alert(i18n.requiredAccessories);
            return false;
        }
    });

    $('body').on('click', expressPaypalSelectors, function (e) {
        const isValid = validateRequiredAccessories();
        toggleExpress(isValid);

        if (isValid) {
            return true;
        }

        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
    });

    function update_selected(old_value, new_value) {
        let results = {};
        if (old_value.length > 0) {
            results = JSON.parse(old_value);
            if (new_value.value == '') {
                delete results[new_value.target];
            } else {
                results[new_value.target] = new_value.value;
            }
        } else {
            results[new_value.target] = new_value.value;
        }
        return JSON.stringify(results);
    }

    function reinitSelect2() {
        const selectClass = '.js-select2';
        let args = {
            width: '100%',
            height: 'resolve',
            minimumResultsForSearch: -1,
            containerCssClass: 'product-card-select',
            dropdownCssClass: 'product-card-select-dropdown',
            selectionCssClass: 'product-card-select-selection',
        };
        $(selectClass).select2(args);
    }

    function bootstrapExpressValidation() {
        toggleExpress();

        if (typeof window === 'undefined') {
            return;
        }

        window.setTimeout(toggleExpress, 300);
        window.setTimeout(toggleExpress, 1000);
    }
})(jQuery);
